// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__iO_n_","view-subtitle":"styles_view-subtitle__SAicK","subtitle-animated":"styles_subtitle-animated__2Nnaq","view":"styles_view__t_DZ_"};